import { useState } from 'react';
import { Modal } from 'react-bootstrap';

export function EmbedWidgetsModal({ show, onHide, widget_id, type, target }) {
    const scriptTag = `<masjidal-widget \n async \n widget-id='${widget_id}' type='${type}' target='${target}'> \n</masjidal-widget>`;
    const [copySuccess, setCopySuccess] = useState('');

    const handleCopy = async () => {
        await navigator.clipboard.writeText(scriptTag);
        setCopySuccess('Copied!');
        setTimeout(() => setCopySuccess(''), 2000);
    };

    return (
        <Modal show={show} onHide={onHide} centered size="md">

            <Modal.Body style={{
                paddingLeft: '1.5rem',
                paddingRight: '1.5rem',
                paddingTop: '1rem',
                paddingBottom: '1rem'
            }}>
                <div className="d-flex justify-content-between align-items-center mb-4">
                    <h5 className="mb-0">How to embed widgets on your website</h5>
                </div>
                <div style={{
                    backgroundColor: '#d3d3d340',
                    padding: '1rem',
                    borderRadius: '10px',
                    color: 'black'
                }
                }>


                    <ol className="ps-3">
                        <li className="mb-4">
                            Copy the code snippet below and place it anywhere you'd like to on your HTML page.
                            <div className="position-relative mt-2">
                                <pre
                                    className="bg-light border rounded p-3 overflow-auto"
                                    style={{ whiteSpace: 'pre-wrap' }}
                                >
                                    {scriptTag}
                                </pre>
                                <button
                                    className="btn btn-outline-primary btn-sm position-absolute top-0 end-0 m-2"
                                    onClick={handleCopy}>
                                    {copySuccess ? copySuccess : 'Copy'}
                                </button>
                            </div>
                        </li>
                    </ol>
                </div>
                <div className="mt-4 text-black">
                    <span >Still need help? </span>
                    <span className='cursor-pointer text-primary'>masjidsupport@masjidal.com</span>
                </div>
            </Modal.Body>
        </Modal>
    );
}
